import { render } from "./InputAduan.vue?vue&type=template&id=248e0554"
import script from "./InputAduan.vue?vue&type=script&lang=js"
export * from "./InputAduan.vue?vue&type=script&lang=js"

import "./InputAduan.vue?vue&type=style&index=0&id=248e0554&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__